/**
 * Adjuntos de solicutud de pago
 *
 */
import React from 'react'
import { message, Table, Button, Menu, Dropdown, Popconfirm, Modal, Icon } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'
import Colors from '../../../Colors'

class SolicitudPagoAdjuntos extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    // this.requestNewFile(record, record.sFiltro)
    this.columns = Cell.buildList([
      { title: 'DOCUMENTO', dataIndex: 'documento.sNombre', width: 200 },
      {
        title: 'NOMBRE', dataIndex: 'dFecha', width: 400,
        render: (_, record) => (
          <span>
            <a href={Api.to(`/upload/file/${record.iIdArchivo}`)} download={record.archivo.sDescripcion}>
              {record.archivo.sDescripcion}
            </a>
          </span>
        )
      },
      { title: 'FECHA', dataIndex: 'dFecha', width: 250, render: val => val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '' },
      {
        title: 'STATUS', dataIndex: 'sComentario', width: 200,
        render: (comentario, record) => {
          const status = !record.iAceptado && !record.iRechazado ? null : (
            record.iAceptado || !record.iRechazado
          )

          return (
            <div style={{ display: 'flex' , flexDirection: 'row', alignItems: 'center' }}>
              <Icon type={status !== null ? (status ? 'check' : 'close') : 'clock-circle'} style={{ fontSize: 16, color: status === null ? 'inherit' : (status ? Colors.success : Colors.error ) }} />
              <span style={{ marginLeft: 5 }}>{status !== null ? comentario : 'EN REVISIÓN'}</span>
            </div>
          )
        }
      },
      {
        title: 'ACCIONES', dataIndex: 'dFecha', width: 100,
        render: (val, record) => (
          <Popconfirm title='¿Eliminar?' onConfirm={() => this.remove(record)}>
            <Button size='small' icon='delete' />
          </Popconfirm>
        )
      },
    ])

    this.state = {
      templates: [],
      data: [],
      isPending: false,
      loading: false,
      solicitudId: 0,
    }

    this.requestNewFile = this.requestNewFile.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
    this.remove = this.remove.bind(this)
    this.load = this.load.bind(this)
  }

  /**
   * show
   */
  show() {
    this.setState({ visible: true })
  }

  /**
   * Load
   *
   * @param {Number} solicitudId
   */
  load(solicitudId) {
    this.setState({
      visible: true,
      loading: true,
      templates: [],
      data: [],
      solicitudId,
    })

    const query = {
      documentos: {
        model: 'AppDocumento'
      },
      adjuntos: {
        attributes: ['iId', 'dFecha', 'iIdArchivo', 'iAceptado', 'iRechazado', 'sComentario'],
        model: 'CxpOrdenPagoAdjunto',
        include: [
          { as: 'archivo', attributes: ['sDescripcion'] },
          { as: 'documento', attributes: ['sNombre'] }
        ],
        where: {
          iIdOrdenPago: solicitudId,
          iIdUsuario: null,
          iActivo: true
        }
      },
      solicitud: {
        __returnType: 'one',
        model: 'CxpOrdenPago',
        attributes: ['sEstado'],
        where: { iId: solicitudId },
      }
    }

    Api.query.list(query)
      .then(response => {
        const isPending = response.data.solicitud.sEstado === 'PENDIENTE'
        this.setState({
          loading: false,
          templates: isPending ? response.data.documentos : [],
          data: response.data.adjuntos,
          isPending,
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * Cargar de archivo
   *
   * @param {Object} file
   * @param {Object} template
   */
  uploadFile(file, template) {
    const closeMessage = message.loading('Cargando', 0)
    this.setState({ loading: true })

    // actualizar la ui
    const closeLoadings = () => {
      this.setState({ loading: false })
      closeMessage()
    }

    const data = Api.form({
      upload: file,
      tipo: 'PROVIDER.CXP.PAYMENT_REQUEST',
      iIdDocumento: template.iId,
    })

    Api.post(`/cxp/solicitudes-pago/${this.state.solicitudId}/proveedor/adjuntos`, data)
      .then(() => {
        closeLoadings()
        message.success('Listo')
        this.load(this.state.solicitudId)
      })
      .catch(error => {
        closeLoadings()
        Exception.load(error).show()
      })
  }

  /**
   * Eliminar
   */
  remove(record) {
    this.setState({ loading: true })

    Api.delete(`/cxp/solicitudes-pago/adjuntos/${record.iId}`)
      .then(() => {
        message.success('Eliminado')
        this.setState({
          loading: false,
          data: this.state.data.filter(item => item.iId !== record.iId)
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * Solicitar archivo a usuario
   *
   */
  requestNewFile(template) {
    if (!template) {
      return
    }

    var input = document.createElement('input')
    input.type = 'file'
    input.accept = template.sFiltro
    input.onchange = e => {
      if (input.files.length > 0) {
        this.uploadFile(input.files[0], template)
      }
      input.value = null
    }

    input.click()
  }

  /**
   * Render
   *
   */
  render() {
    const { templates } = this.state
    return (
      <Modal
        title='ADJUNTOS'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '80%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='guardar'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='Cerrar'
          />
        ]}
        children={[
          <div key='1' style={{ marginBottom: 15 }}>
            <Dropdown
              overlay={
                <Menu onClick={e => this.requestNewFile(templates.find(_ => _.iId.toString() === e.key))}>
                  {templates.map(template =>
                    <Menu.Item key={template.iId}>
                      <Icon type='link' style={{ marginRight: 5 }} />
                      <span>{template.sNombre}</span>
                    </Menu.Item>
                  )}
                </Menu>
              }
              children={
                this.state.isPending ? (<Button type='primary'>ADJUNTAR</Button>) : <span></span>
              }
            />
          </div>,
          <Table
            key='2'
            rowKey='iId'
            size='small'
            loading={this.state.loading}
            columns={this.columns}
            pagination={false}
            dataSource={this.state.data}
            bordered={false}
          />
        ]}
      />
    )
  }
}

export default SolicitudPagoAdjuntos
